import { render } from "./TileButton.vue?vue&type=template&id=a2a1a0ae&ts=true"
import script from "./TileButton?vue&type=script&lang=ts"
export * from "./TileButton?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__